<template>
  <div class="sort" @click="changeSort()">
    <i class="el-icon-d-caret" v-show="!model"></i>
    <i class="el-icon-caret-top" v-show="model === 'asc'"></i>
    <i class="el-icon-caret-bottom" v-show="model === 'desc'"></i>
  </div>
</template>

<script>
  export default {
    name: "Sort",
    props: ['model'],
    mounted: function () {

    },
    methods: {
      changeSort: function () {
        switch (this.model) {
          case null:
            this.$emit('change', 'asc')
            break;
          case 'asc':
            this.$emit('change', 'desc')
            break
          default:
            this.$emit('change', null)
            break
        }
      }
    }
  }
</script>
<style lang="scss">
  .sort {
    cursor: pointer;
  }
</style>